import { Outlet } from 'react-router-dom';

export const FindSpecialistPage = () => {
	return <Outlet />;
};
